import './index.css';
import 'swiper/css';
import React from "react";
import Main from "./Main";
import {MemoryRouter} from "react-router-dom";

function App() {
    return (
        <MemoryRouter>
            <Main />
        </MemoryRouter>
    );
}

export default App;
